import { getMindsetSum } from './helper';

const lastLogSignatureByPage = new Map();

const normaliseVariableName = (variable) =>
  String(variable || '').toLowerCase().replace(/[^a-z0-9]/g, '');

const getMindsetAnswer = (variables, questionNumber) => {
  const answers = variables.filter((item) => {
    const name = normaliseVariableName(item?.variable);
    return name.startsWith('mindset') && name !== 'mindsetsum';
  });

  const matchedAnswer = answers.find((item) => {
    const suffix = normaliseVariableName(item.variable).replace('mindset', '');
    const number = suffix.match(/(\d+)$/)?.[1];
    return Number(number) === questionNumber;
  });

  // Legacy data can name the first answer simply "mind_set".
  const unnamedFirstAnswer = questionNumber === 1
    ? answers.find((item) => normaliseVariableName(item.variable) === 'mindset')
    : undefined;

  return matchedAnswer?.score ?? unnamedFirstAnswer?.score;
};

const getMembers = (apiData) => {
  const allMembersData = Object.values(apiData?.memberResults?.allMembersData || {});
  if (allMembersData.length) return allMembersData;

  if (apiData?.memberResults?.data?.variables) {
    return [apiData.memberResults.data];
  }

  return Array.isArray(apiData?.memberResults?.members)
    ? apiData.memberResults.members
    : [];
};

const toRow = (assessment, source) => {
  if (!Array.isArray(assessment?.variables)) return null;

  const totalScore = getMindsetSum(assessment.variables);
  if (totalScore === 0) return null;

  const answers = Object.fromEntries(
    Array.from({ length: 12 }, (_, index) => [
      `Mindset ${index + 1}`,
      getMindsetAnswer(assessment.variables, index + 1) ?? '-',
    ])
  );

  return {
    Person: assessment.fullName || assessment.name || assessment.hash || 'Unknown',
    Relationship: assessment.designation || source,
    Source: source,
    ...answers,
    'Mindset score': totalScore,
  };
};

/**
 * Logs each respondent's Mindset answers and score used by the results page.
 */
export const logMindsetIndividualAnswers = ({ apiData, reportType }) => {
  if (!apiData) return;

  const rows = [
    toRow(apiData, 'SELF'),
    ...(reportType === '360 REPORT'
      ? getMembers(apiData).map((assessment) => toRow(assessment, '360'))
      : []),
  ].filter(Boolean);

  if (!rows.length) return;

  const pageName = reportType === '360 REPORT' ? 'Mindset Results 360' : 'Mindset Results Self';
  const signature = JSON.stringify(rows);
  if (lastLogSignatureByPage.get(pageName) === signature) return;

  lastLogSignatureByPage.set(pageName, signature);
  console.groupCollapsed(`[Mindset – individual answers] ${pageName}`);
  console.table(rows);
  console.log('Copyable individual-answer data:', rows);
  console.groupEnd();
};
